import { Component } from '@angular/core';

import { EmptyStateComponent } from '@echospaces-web-monorepo/es-shared-ui';

/**
 * Coming-soon stub for subscription / billing. Lands once a billing
 * provider is integrated; for now it just declares the slot so the
 * admin overview can link to it.
 */
@Component({
  selector: 'es-admin-billing-page',
  imports: [EmptyStateComponent],
  template: `
    <div class="max-w-4xl mx-auto">
      <div class="mb-6">
        <h1 class="text-2xl font-bold font-exo">Billing</h1>
        <p class="text-sm text-[var(--text-secondary)]">
          Plan, usage, and invoices — coming soon.
        </p>
      </div>
      <es-empty-state
        title="Billing"
        description="Plan selection, current usage, and invoice history will appear here once the billing backend is wired up."
        icon="💳"
      ></es-empty-state>
    </div>
  `,
})
export class AdminBillingPageComponent {}
